export default "__VITE_ASSET__ZNQTOf2l__"